import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { downloadCSV, fetchDataCallOnInitialLoad } from "../../../common_nextgen/utils/UtilFunctions";

const useCouponPatientPayGPIList = () => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [hideFlag, setHideFlag] = useState(false);
  const [lookupType, setLookupType] = useState("");
  const [selectParams, setSelectParams] = useState([]);
  const [selectMode, setSelectMode] = useState(false);
  const toast = useToast();
  const location = useLocation();
  const {
    COUPON_PATIENT_PAY_ADD,
    COUPON_PATIENT_PAY_EDIT,
    COUPON_PATIENT_PAY_DISPLAY,
    COPY_COUPON_PATIENT_PAY_GPI_LIST,
    COUPON_PATIENT_PAY_GPI_LIST_NOTE,
    COUPON_PATIENT_PAY_GPI,
    COUPON_PATIENT_PAY_GPI_LIST_PLANS,
  } = ROUTE_PATHS;

  const screen_title = "Coupon Patient Pay GPI List";
  const [screenNumber, setScreenNumber] = useState(selectMode ? "RCCPF004" : "RCCPF001");

  const stateVal = Array.isArray(location?.state) ? location.state : [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      cpfGpiListName: "",
      cpgGenericProductId: "",
    },
  } = currentState;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(initialParamsData);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.cpfGpiListName;
  const updatedParamsData = {
    ...paramsData,
    cpfGpiListName: lastScheduleName,
  };

  const formFields = [
    {
      fieldLabel: "CPF GPI List Name",
      name: "cpfGpiListName",
      label: "List",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  const leftButtons = selectMode ? [{
    button_label: "Back",
    button_key: "F12",
    button_handeler: () => {
      if (lookupType === "external") {
        const message = { type: "hideModal" };
        window.parent.postMessage(message, "*");
      }
    }
  }] : [];

  const ctaButtons = selectMode ? [{
    button_label: "Export as CSV",
    button_handeler: () => {
      exportAsCSV();
    },
    button_key: "",
  }] : [{
    button_label: "Add Coupon Patient Pay GPI List",
    button_handeler: () => {
      navigateToPage(COUPON_PATIENT_PAY_ADD, [{
        selectedSchedules: selectedRows.length ? selectedRows : [rowData],
        previousScreen: location.pathname,
        currentIndex: 0,
      }]);
    },
    button_key: "F6",
  },
  {
    button_label: "Export as CSV",
    button_key: "",
    button_handeler: () => exportAsCSV(),
  }];

  const menuOptions = selectMode ? [{
    label: "Select",
    icon: <span className="material-icons">add</span>,
    command: () => {
      try {
        const paramDataMap = new Map();
        selectParams.forEach(key => {
            if (rowData.hasOwnProperty(key["target"])) {
              paramDataMap.set(key["source"], rowData[key["target"]]);
            }
        });
        const paramData = Object.fromEntries(paramDataMap);
        if (lookupType === "external") {
          const message = { type: "responseData", data: paramData };
          window.parent.postMessage(message, "*");
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  {
    label: "Display",
    icon: <span className="material-icons">visibility</span>,
    command: () => {
      if (lookupType === "external") {
        const message = {
          type: "navigateData",
          data: { ...rowData },
          target: "COUPON_PATIENT_PAY_DISPLAY_READ_ONLY",
          schedulesDataKey: "selectedSchedules",
        };
        window.parent?.postMessage(message, "*");
      }
    }
  },
  {
    label: "GPIs",
    icon: <span className="material-icons">list</span>,
    command: () => {
      if (lookupType === "external") {
        const message = {
          type: "navigateData",
          data: { ...rowData },
          target: "COUPON_PATIENT_PAY_GPI_READ_ONLY",
          schedulesDataKey: "selectedSchedules",
        };
        window.parent?.postMessage(message, "*");
      }
    }
  }] : [{
    label: "Note",
    icon: <span className="material-icons">note</span>,
    command: () => {
      navigateToPage(COUPON_PATIENT_PAY_GPI_LIST_NOTE, [
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
        {
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],
          previousScreen: location.pathname,
        },
      ]);
    },
  },
  {
    label: "Edit",
    icon: <span className="material-icons">edit</span>,
    command: () => {
      navigateToPage(COUPON_PATIENT_PAY_EDIT, [
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
        {
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],
          previousScreen: location.pathname,
          // currentIndex: 0,
        },
      ]);
    },
  },
  {
    label: "Copy",
    icon: <span className="material-icons">content_copy</span>,
    command: () => {
      navigateToPage(COPY_COUPON_PATIENT_PAY_GPI_LIST, [
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
        {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData],
          previousScreen: location.pathname,
        },
      ]);
    },
  },
  {
    label: "Delete",
    icon: <span className="material-icons">delete</span>,
    command: () => {
      openConfirmationModal();
    },
  },
  {
    label: "Display",
    icon: <span className="material-icons">visibility</span>,
    command: () => {
      navigateToPage(COUPON_PATIENT_PAY_DISPLAY, [
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
        {
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],
          previousScreen: location.pathname,
          currentIndex: 0,
        },
      ]);
    },
  },
  {
    label: "GPIs",
    icon: <span className="material-icons">list</span>,
    command: () => {
      navigateToPage(COUPON_PATIENT_PAY_GPI, [
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
        {
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],
          previousScreen: location.pathname,
          currentIndex: 0,
        },
      ]);
    },
  },
  {
    label: "Plans",
    icon: <span className="material-icons">assignment</span>,
    command: () => {
      navigateToPage(COUPON_PATIENT_PAY_GPI_LIST_PLANS, [
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
        {
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],
          previousScreen: location.pathname,
          currentIndex: 0,
        },
      ]);
    },
  }];

  const columnDef = [
    { header: "List", field: "cpfGpiListName" },
    { header: "Description", field: "cpfGpiListDescription" }
  ];

  const parmKey = "cpfGpiListName";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header("GET", `api/couponPatPayGpiList`, null, { page: page, size: rows, ...paramsData });
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({ severity: "info", summary: "", detail: response.responseStatus.message, life: 3000 });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, hideFlag, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteCouponPatientPayGPIList = () => {
    if (selectedOption === "yes") {
      let listNames = [];

      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        listNames = selectedRows.map((row) => row.cpfGpiListName);
      } else if (rowData && Object.keys(rowData).length > 0) {
        listNames[0] = rowData.cpfGpiListName;
      }

      if (listNames.length > 0) {
        axios_helper_no_header(
          "DELETE",
          "api/couponPatPayGpiList",
          listNames,
          null
        )
          .then((response) => {
            const updatedItems = data.filter(
              (item) => item[parmKey] !== rowData
            );
            setTotalRecords((prevTotal) => prevTotal - 1);
            setData(updatedItems);
            // fetchData();
            if (currentPage > 0) {
              setFirst(0);
              setCurrentPage(0);
            } else {
              fetchData();
            }
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeConfirmationModal();
          })
          .catch((error) => {
            console.error("There was an error deleting the data!", error);
            const errorMessage =
              error.data?.responseStatus?.message || error.message;
            toast.current.show({
              severity: "error",
              summary: "",
              detail: errorMessage,
              life: 3000,
            });
            closeConfirmationModal();
          });
      } else {
        closeConfirmationModal();
      }
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData, screenNumber });

    try {
      const response = await axios_helper_no_header("GET", "api/couponPatPayGpiList/exportCsv", null, queryParams, "blob");
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData(prev => ({ ...prev, ...paramData.paramsData }));
      setSelectMode(selectMode);
      if (paramData.screenNumber)
        setScreenNumber(paramData.screenNumber);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  return {
    screenNumber,
    screen_title,
    selectMode,
    formFields,
    dropdownValues,
    paramsData,
    leftButtons,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteCouponPatientPayGPIList,
    setSelectedOption,
  };
};

export default useCouponPatientPayGPIList;